document.addEventListener('DOMContentLoaded', function () {
    const swiperOptions = {
        slidesPerView: 'auto',
        watchOverflow: true,
        observer: true,
        loop: true,
        observeParents: true,
        on: {
            slideChangeTransitionEnd: function() {
                this.update();
            },
            resize: function() {
                this.update();
            }
        }
    };

    // Swiper do recentlyViewed será inicializado após os slides serem carregados
    window.initRecentlyViewedSwiper = function() {
        new Swiper('.carousel-recentlyViewed', {
            ...swiperOptions,
            navigation: {
                nextEl: ".carousel-products .carousel-recentlyViewed .swiper-button-next",
                prevEl: ".carousel-products .carousel-recentlyViewed .swiper-button-prev",
            }
        });
    }

    // Complementary Products Swiper
    window.initComplementaryProductsSwiper = function() {
        new Swiper('.carousel-complementaryProducts', {
            ...swiperOptions,
            navigation: {
                nextEl: ".carousel-products .carousel-complementaryProducts .swiper-button-next",
                prevEl: ".carousel-products .carousel-complementaryProducts .swiper-button-prev",
            }
        });
    }


    const secondCarousel = new Swiper('.carousel-recommended', {
        ...swiperOptions,
        navigation: {
            nextEl: ".carousel-products .carousel-recommended .swiper-button-next",
            prevEl: ".carousel-products .carousel-recommended .swiper-button-prev",
        }
    });

    const tabs = document.querySelectorAll('.carousel-tab');
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const carouselId = tab.dataset.carousel;
            
            tabs.forEach(t => t.classList.remove('is-active'));
            tab.classList.add('is-active');

            document.querySelector('.carousel-recentlyViewed').classList.remove('active');
            document.querySelector('.carousel-recommended').classList.remove('active');
            document.querySelector('.carousel-' + carouselId).classList.add('active');
        });
    });
}); 